<template>
  <section class="bg-dark bg-gradient contact-bg">
    <div class="container py-5 rl z">
      <div class="row color-white align-items-center my-0 my-lg-5">
        <div class="col-12 col-md-6">
          <div class="fs-4">
            <div class="mb-4 fade-in-item up">
              <div class="f-sm h-op">Contact:</div>
              Bryan Ware
            </div>
            <div class="mb-4 fade-in-item up">
              2206 N Cloverleaf Way<br />
              Saratoga Springs, UT 84045
            </div>
            <div class="mb-4 bld fade-in-item up">For sale: ${{ price }}</div>
            <div class="mb-3 fade-in-item up">‪
              <a href="tel:8013827967‬" class="mb-3 aa lbld color-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="28px"
                  viewBox="0 -960 960 960"
                  width="28px"
                  class="me-2"
                  fill="#fff"
                >
                  <path
                    d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"
                  />
                </svg>

                ‪(801) 382-7967‬
              </a>
            </div>
            <div class="fade-in-item up">
              <!-- <a href="mailto:bryan@warerepair.net" class="aa lbld color-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="28px"
                  viewBox="0 -960 960 960"
                  class="me-2"
                  width="28px"
                  fill="#fff"
                >
                  <path
                    d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                  />
                </svg>

                bryan@warerepair.net
              </a> -->
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mt-5 mt-lg-0 fade-in-item up">
          <form action="#" method="post" @submit.prevent="contact()">
            <div class="f-xlg bld mb-0">Contact us</div>
            <div class="f-lg mb-3 l-op">Have any questions?</div>
            <div v-show="success" class="success-message mb-3">
              Awesome! We got your message and will contact you soon!
            </div>
            <div class="form-g mb-2">
              <label for="name" class="mb-2">Name</label>
              <input
                type="text"
                id="name"
                class="form-control"
                v-model="form.name"
                placeholder="Name"
                required="required"
                :disabled="requestSent"
              />
              <input
                type="text"
                id="last-name"
                class="form-control d-n"
                v-model="honeypot"
                placeholder="Last Name"
                :disabled="requestSent"
              />
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-g mb-2">
                  <label for="phone" class="mb-2">Phone</label>
                  <input
                    type="text"
                    id="phone"
                    v-model="form.phone"
                    class="form-control"
                    placeholder="Phone"
                    required="required"
                    :disabled="requestSent"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-g mb-2">
                  <label for="name" class="mb-2">Email</label>
                  <input
                    type="email"
                    id="name"
                    v-model="form.email"
                    class="form-control"
                    placeholder="Email"
                    required="required"
                    :disabled="requestSent"
                  />
                </div>
              </div>
            </div>
            <div class="form-g mb-4">
              <label for="message" class="mb-2">Message</label>
              <textarea
                id="message"
                class="form-control"
                placeholder="Message"
                v-model="form.message"
                :disabled="requestSent"
                max="2500"
                rows="3"
              ></textarea>
            </div>
            <button
              class="btn btn-primary bld"
              type="submit"
              :disabled="requestSent"
            >
              Send Message
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#fff"
                class="ms-2"
              >
                <path
                  d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z"
                />
              </svg>
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      requestSent: false,
      success: false,
      honeypot: "",
      form: {
        name: "",
        phone: "",
        email: "",
        message: "",
      },
    };
  },
  props: ["price"],
  methods: {
    reset() {
      this.form.name = "";
      this.form.email = "";
      this.form.phone = "";
      this.form.message = "";
    },
    contact() {
      if (this.requestSent) return;

      if (this.honeypot != "") {
        return;
      }

      this.requestSent = true;
      axios
        .post("https://submit-form.com/coOCRWPfH", this.form)
        .then((response) => {
          //this.requestSent = false;
          this.success = true;
          console.log(response);
        })
        .catch((response) => {
          this.requestSent = false;
          console.error(response);
        });
    },
  },
};
</script>

<style>
.success-message {
  background-color: #1ec71e59;
  color: #bbffaf;
  padding: 15px;
  border-radius: 8px;
}
.contact-bg {
  position: relative;
}
.contact-bg:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url("https://cdn.lennar.net/api/images/images/com/images/new-homes/26/132/7901/66151/room/UTH_2482_Pic_Mesa_Kitchen_1of2_F1_Base4.jpg?d=20240630T114143Z&w=1600");
  background-size: cover;
  background-position: center;
  opacity: 0.075;
  z-index: 0;
}
.d-n {
  display: none;
}
</style>
